import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "256",
      cy: "256",
      r: "256",
      fill: "#f0f0f0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0052b4",
      d: "M496.077 166.957H15.923C5.632 194.69 0 224.686 0 256s5.632 61.31 15.923 89.043h480.155C506.368 317.31 512 287.314 512 256s-5.632-61.31-15.923-89.043"
    }, null, -1),
    _createElementVNode("g", { fill: "#d80027" }, [
      _createElementVNode("path", { d: "M256 0C178.409 0 108.886 34.524 61.939 89.043H450.06C403.114 34.524 333.591 0 256 0M450.061 422.957H61.939C108.886 477.476 178.409 512 256 512s147.114-34.524 194.061-89.043" })
    ], -1)
  ])))
}
export default { render: render }